const personsApi = ({ apiClient }) => ({
  /**
   *
   * @param params
   * @returns {*}
   */
  list(params, headers = {}) {
    return apiClient.get('person', {}, params, headers)
  },

  store(param, headers = {}) {
    return apiClient.post('person', param, false, headers)
  },

  show(id, param = {}, headers = {}) {
    return apiClient.get(`person/${id}`, {}, param, headers)
  },

  update(id, params, headers = {}) {
    return apiClient.put(`person/${id}`, params, headers)
  },

  delete(id, headers = {}) {
    return apiClient.delete(`person/${id}`, headers)
  },
})

export default personsApi
